export const siteUrl = 'https://dev-tuckel.pantheonsite.io'